module.exports = __webpack_public_path__ + "img/1.c021bca4.png";